import { useState } from "react";
import { useTranslation } from "react-i18next";

const ITEMS = [
  { q: "faq.q1", a: "faq.a1" },
  { q: "faq.q2", a: "faq.a2" },
  { q: "faq.q3", a: "faq.a3" },
  { q: "faq.q4", a: "faq.a4" },
  { q: "faq.q5", a: "faq.a5" },
];

export default function Faq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="faq-section" id="faq">
      <span
        className="panel-accent mono"
        aria-hidden="true"
        data-parallax="0.55"
        style={{
          right: "4vw",
          top: "8vh",
          fontSize: "clamp(120px, 18vw, 240px)",
          lineHeight: 1,
          color: "color-mix(in srgb, var(--accent) 9%, transparent)",
        }}
      >
        ?
      </span>
      <div className="faq-inner">
        <div className="relative z-[2]">
          <p className="stamp mono" data-reveal style={{ color: "var(--accent)", letterSpacing: ".16em", fontSize: 11, textTransform: "uppercase" }}>
            {t("faq.stamp")}
          </p>
          <h2
            data-reveal
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "clamp(30px, 4.4vw, 56px)",
              lineHeight: 1.03,
              letterSpacing: "-.03em",
              fontWeight: 600,
              margin: "14px 0 0",
              paddingBottom: ".12em",
            }}
            dangerouslySetInnerHTML={{ __html: t("faq.h2") }}
          />
          <a className="cta mt-6" href="#contact" data-reveal>
            {t("nav.contact")}
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="relative z-[2]">
          {ITEMS.map((item, i) => (
            <div className="faq-row" key={item.q} data-open={open === i} data-reveal>
              <button
                type="button"
                className="faq-q"
                aria-expanded={open === i}
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span>{t(item.q)}</span>
                <i className="ri-add-line text-[20px]" aria-hidden="true" />
              </button>
              <div className="faq-a">
                <div>
                  <p>{t(item.a)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}